import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Clients from './pages/Clients';
import BlogList from './pages/BlogList';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import ServiceProjectDetail from './pages/ServiceProjectDetail';
import PressPage from './pages/PressPage';
import PressReleaseDetails from './pages/PressReleaseDetails';
import ContactPage from './pages/ContactPage.jsx';
import SinglePost from './pages/SinglePost.jsx';
import Career from './pages/Career.js';
import IntroOverlay from './components/IntroOverlay.js';
import { useLocation } from 'react-router-dom';
import ScrollToTop from "./ScrollToTop";

// import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
function App() {
  const location = useLocation();

  return (
    <HelmetProvider>
            <ScrollToTop />

      {/* {location.pathname === '/' && <IntroOverlay />} */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/services/:slug/:project" element={<ServiceProjectDetail />} />
        <Route path="/press" element={<PressPage />} />
        <Route path="/press/press-release/:id" element={<PressReleaseDetails />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog/:slug" element={<SinglePost />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/career" element={<Career />} />
          {/* <Route path="/terms" element={<Terms />} /> */}
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </HelmetProvider>
  );
}

export default App;